<template>
  <div class="marketing-automation-form-steps">

    <div>
      <marketing-automation-form-steps-item :automationId="automationId"
                                            :item="steps[0]"
                                            type="ENTRY"
                                            @submit="setNewStep" />
      <marketing-automation-form-steps-add v-if="hasSteps"
                                           :disabled="needsSaving"
                                           @selected="addStep" />
    </div>

    <div v-for="(step, index) in steps.slice(1)"
         :key="step.id">
      <marketing-automation-form-steps-item :item="step"
                                            :type="step.stepType === 'CHANNEL' ? step.properties.channelType : step.stepType"
                                            :automationId="automationId"
                                            @submit="setNewStep"
                                            @delete="deleteStep($event || (index+ 1))" />
      <marketing-automation-form-steps-add :disabled="needsSaving"
                                           @selected="addStep($event, index + 1)" />
    </div>
  </div>
</template>

<script>
import EventBus from "@packages/event-bus/index";
import MarketingAutomationFormStepsItem from "@components/modules/marketing/automation/form/steps/item/MarketingAutomationFormStepsItem";
import MarketingAutomationFormStepsAdd from "@components/modules/marketing/automation/form/steps/add/MarketingAutomationFormStepsAdd";

export default {
  components: {
    MarketingAutomationFormStepsItem,
    MarketingAutomationFormStepsAdd,
  },

  props: {
    initialSteps: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    automationId: {
      type: String,
    },
  },

  data() {
    return {
      selectedStep: undefined,
      steps: this.initialSteps || [],
    };
  },

  computed: {
    hasSteps() {
      return this.steps.length > 0;
    },
    hasUnsavedStep() {
      return this.steps.some((step) => {
        return !step.id;
      });
    },
    needsSaving() {
      return this.$store.state.marketing.automation.edit.needsSaving;
    },
  },

  watch: {
    hasUnsavedStep(val) {
      this.$store.commit("SET_AUTOMATION_EDIT_NEEDS_SAVING", val);
    },
  },

  methods: {
    formatStepToArray(steps, array = []) {
      array.push({
        ...steps,
        properties: JSON.parse(steps.properties),
      });

      if (steps.next) {
        return this.formatStepToArray(steps.next, array);
      }

      return array;
    },
    setNewStep() {
      this.fetchSteps();
    },
    addStep(item, index = 0) {
      const selectedStep = index ? this.steps[index] : this.steps[0];

      this.steps.splice(index + 1, 0, {
        ...item,
        previousStepId: selectedStep && selectedStep.id,
      });
    },
    async fetchSteps() {
      const steps = await this.$api.marketing.automation.flow.steps({
        automationId: this.automationId,
      });

      if (steps) {
        this.steps = this.formatStepToArray(steps);
      }

      this.hasLoaded = true;
    },
    async deleteStep(stepId) {
      try {
        const isSavedStepId = typeof stepId === "string";

        if (isSavedStepId) {
          EventBus.$emit("SHOW_SPINNER");

          await this.$api.marketing.automation.flow.deleteStep({
            automationId: this.automationId,
            stepId,
          });

          await this.fetchSteps();
        } else {
          this.steps.splice(stepId, 1);
        }
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form-steps {
  margin: 0 auto;
  width: fit-content;
}
</style>
